import { Textarea } from "@centricsoftware/design-system";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useAttributeDefinitionStore } from "./AttributeDefinitionStore";

const AttributeDefinitionSectionNotes: FunctionComponent = observer(() => {
	const { 
		attrNotes,
		locale,
		onChangeNotes,
	} = useAttributeDefinitionStore();

	const { labelNotesRes } = locale;

	return (
		<Textarea
			labelRes={labelNotesRes}
			onChange={onChangeNotes}
			value={attrNotes}
		/>
	);
});

export default AttributeDefinitionSectionNotes;